import { render, staticRenderFns } from "./modal-vincular-contato.vue?vue&type=template&id=b8fc9746&"
import script from "./modal-vincular-contato.vue?vue&type=script&lang=js&"
export * from "./modal-vincular-contato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAvatar,VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8fc9746')) {
      api.createRecord('b8fc9746', component.options)
    } else {
      api.reload('b8fc9746', component.options)
    }
    module.hot.accept("./modal-vincular-contato.vue?vue&type=template&id=b8fc9746&", function () {
      api.rerender('b8fc9746', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/modal/modal-vincular-contato/modal-vincular-contato.vue"
export default component.exports